'use client'

import React, { FC, ReactElement } from 'react'
import styles from './DonateModal.module.css'
import Modal from '@/components/modal'
import classnames from 'classnames'
import QRCode from 'react-qr-code'
import CopyButton from '@/components/copy-button'
import Tabs from '@/components/tabs'
import { NETWORK } from '@/utils/constants'

type Tab = 'BTC' | 'ETH' | 'DOGE'

const ADDRESS =
	NETWORK === 'BTC'
		? 'bc1qpq6600v0kuapsasv99jr24zrjhz83qk0s7fk32'
		: 'D7z6jpYTKXhEDrt5VEmJAbdcs8cVhrwfrE'

const DonateModal: FC<{ open: boolean; onClose: (evt: any) => void }> = (props): ReactElement => {
	// @ts-ignore
	const [address, setAddress] = React.useState(ADDRESS)
	// @ts-ignore
	const [tab, setTab] = React.useState<Tab>(NETWORK)
	const leadingCharacters = React.useMemo(() => {
		if (address && address?.length > 40) {
			return address.slice(0, 15)
		} else {
			return null
		}
	}, [address])
	const trailingCharacters = React.useMemo(() => {
		if (address && address?.length > 40) {
			return address.slice(-15)
		} else {
			return null
		}
	}, [address])

	const tabs = React.useMemo(
		() => [
			{
				title: NETWORK,
				onClick: () => {
					// @ts-ignore
					setTab(NETWORK)
					setAddress(ADDRESS)
				},
				selected: tab === NETWORK
			},
			{
				title: 'BTC',
				onClick: () => {
					setTab('BTC')
					setAddress('bc1qpq6600v0kuapsasv99jr24zrjhz83qk0s7fk32')
				},
				selected: tab === 'BTC'
			},
			{
				title: 'ETH',
				onClick: () => {
					setTab('ETH')
					setAddress('0x3228A08DF1d42b5201796A8C8Ed5566399096460')
				},
				selected: tab === 'ETH'
			}
		],
		[tab]
	)

	return (
		<Modal open={props.open} onClose={props.onClose}>
			<div className={styles.root}>
				<Tabs tabs={tabs} />
				<div className={styles.qrContainer}>
					<div className={styles.qrCode}>
						<QRCode
							size={256}
							style={{ height: 'auto', margin: '0 auto', width: '100%' }}
							value={address}
							viewBox="0 0 256 256"
						/>
					</div>
				</div>
				<p className={classnames(styles.address, 'text-sm')}>
					{trailingCharacters && leadingCharacters
						? leadingCharacters + '...' + trailingCharacters
						: address}
				</p>
				<CopyButton
					value={address}
					label={'Copy to clipboard'}
					className={styles.copy}
					iconClassName={styles.copyIcon}
				/>
			</div>
		</Modal>
	)
}

export default DonateModal
